import { Navigate, useLocation } from 'react-router-dom';

/** Preserves ?token= when redirecting legacy /claim-confirm links. */
const ClaimConfirmRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/dashboard/my/participants/claim${search}`} replace />;
};

export default ClaimConfirmRedirect;
